<template>
  <div>
    <div id="main"
         class="wh1200">
      <div class="home_top">
        <div class="top_swiper">

          <swiper ref="mySwiper"
                  :options="swiperOptions1">
            <swiper-slide v-for="(item,index) in carousel"
                          :key="index">
              <a :href="item.blank"
                 class="swiper_img">
                <div class="swiper_text-content">
                  <img :src="item.face"
                       alt=""
                       srcset="">
                  <div class="swiper_text">{{item.name}}</div>
                </div>
              </a>
            </swiper-slide>

            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>

        </div>

        <div class="right_tuijian">

          <div v-for="(item, index) in overall"
               :key="item">
            <div v-if="index == 1 || index == 0 "
                 :class="item.types == 10?'a_zhuanti': 'a_toutiao'">

              <a :href="item.href"
                 target="_blank">
                <div>{{item.title}}</div>
              </a>
            </div>
            <div v-else
                 :class="item.types == 10?'a_zhuanti': ''"> <a :href="item.href">
                <div>{{item.title}}</div>
              </a></div>
          </div>

        </div>

      </div>

      <div class="tongzhi">
        <a href="javascript:;"
           class="tongzhi_name"><img src="../static/tongzhi_icon.png"
               alt="">通知公示</a>
        <div class="tongzhi_content">
          <div class="tongzhi_box">

            <div class="tongzhi_link inner-container">
              <vue-seamless-scroll :data="publicity"
                                   :class-option="optionSeamless"
                                   class="seamless-warp">
                <a :href="'/publicinfo?id='+item.publicity_id"
                   v-for="(item,index) in publicity"
                   :key="index"
                   :data-id="item.publicity_id">{{item.title}}</a>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
      <a href="javascript:;"
         class="adv_01">
        <!-- <img src="../static/icon_01.png"
             alt=""> -->

        <img v-for="(item,index) in advertising"
             @click="navImageClick(item.advertising_href)"
             :key="index"
             v-if="item.advertising_id == 1"
             :src="item.advertising_image"
             style="width:1200px;height:160px;"
             alt="">
      </a>

      <div class="zixun_pingtai">
        <div class="zixun_box">
          <div class="home_title"><a href="javascript:;"
               class="left">产业资讯</a><a href="/informationlist?id="
               class="right">更多
              ></a></div>
          <div class="zixun_box_content">
            <a :href="'informationinfo?id='+item.information_id"
               v-for="(item,index) in product"
               :key="index"
               data-id="item.information_id">
              <div v-for="(items,index) in typelist"
                   :key="index"
                   v-if="items.types_id == item.types">
                [<span>{{items.name}}</span>]{{item.title}}</div>
            </a>
          </div>
        </div>
        <div class="pingtai_box">
          <div class="home_title"><span class="left">服务平台</span></div>
          <ul>
            <li v-for="(item,index) in overallserver"
                :key="index"><a :href="item.herf"
                 target="_blank">{{item.name}}</a></li>
          </ul>

          <div class="home_title"><a href="javascript:;"
               class="left">杂志阅览</a><a href="/zhazhi"
               class="right">更多 ></a></div>
          <div class="pingtai_swiper">
            <swiper ref="mySwiper"
                    :options="swiperOptions">
              <swiper-slide v-for="(item,index) in zhazhilist"
                            :key="index">
                <div class="swiper_box">
                  <div class="box_list">
<!--                    <a @click="bookClick(item,1)" :style="{'background': 'url(' + item.face + ')', 'background-repeat':'no-repeat','background-position':'center'}"></a>-->
<!--                    <a :href="item.contentfile instanceof Array ? JSON.parse(item.contentfile)[0].url : item.contentfile" target="_blank" :style="{'background': 'url(' + item.face + ')', 'background-repeat':'no-repeat','background-position':'center'}"></a>-->
                    <a :href="magazineDataFormat(item)" target="_blank" :style="{'background': 'url(' + item.face + ')', 'background-repeat':'no-repeat','background-position':'center'}"></a>
                  </div>
                  <div class="box_list">
<!--                    <a  @click="bookClick(item,2)" :style="{'background': 'url(' + item.content + ')', 'background-repeat':'no-repeat','background-position':'center'}">-->
<!--                      <div @click="bookClick(item,2)" class="swiper_text">{{item.title}}</div>-->
<!--                    </a>-->
                    <a :href="magazineDataFormats(item)" target="_blank" :style="{'background': 'url(' + item.content + ')', 'background-repeat':'no-repeat','background-position':'center'}">
                      <div :href="magazineDataFormats(item)" class="swiper_text">{{item.title}}</div>
                    </a>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper_button_box">
              <div class="swiper-button-prev"
                   　slot="button-prev"></div>
              <div class="swiper-button-next"
                   　slot="button-next"></div>
            </div>
          </div>
          <div class="zazhi_dingzhi">
            <div class="left_box">
              <div class="left_b_name">《中国林业产业》杂志订阅信息</div>
              <div class="left_b_text">广告热线：010-64283516</div>
            </div>
            <div class="right_img"><img src="../static/right_img.png"
                   alt=""></div>
          </div>

        </div>
      </div>

      <div class="adv_02">
        <ul>
          <li v-for="(item,index) in advertising"
              @click="navImageClick(item.advertising_href)"
              :key="index"
              v-if="item.advertising_id == 4 ||item.advertising_id == 5||item.advertising_id == 6">

            <img :src="item.advertising_image"
                 style="width:386px;height:230px;cursor:pointer"
                 alt="">
          </li>

        </ul>
      </div>
      <div class="shengtai">
        <div class="home_title"><a href="javascript:;"
             class="left">国家森林生态标志产品</a><a href="/linbiaolist"
             class="right">更多 ></a></div>

        <div class="shengtai_swiper">

          <swiper ref="mySwiper"
                  :options="swiperOptions2">
            <swiper-slide v-for="(item,indexs) in forest"
                          :key="indexs">
              <!-- {{item}} -->
              <div class="swiper_text-content swiper_text-contents">
                <div v-for="(items,index) in item.data"
                     @click="navlibiaoClick(items)"
                     :key="index"
                     :style="index==1?'margin-left:20px':''">
                  <div class="top_img" v-if="items.face"
                       :style="{'background': 'url(' + items.face + ')', 'background-repeat':'no-repeat','background-position':'center'}"></div>
                       <img class="top_img" v-else src="../static/left_box_img01.jpg"/>
                  <div class="swiper_texts_shengtai_swiper">
                    <span style="    font-size: 16px;
                    color: #333333;">{{items.title}}</span>
                    <span style="font-size: 14px;
                    color: #888888;
                    line-height: 20px;
                    height: 40px;
                    display: -webkit-box !important;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    margin-top: 10px;">{{items.subhead}}</span>
                  </div>

                </div>
              </div>
            </swiper-slide>
            <div class="swiper-button-prev"
                 slot="button-prev"></div>
            <div class="swiper-button-next"
                 slot="button-next"></div>

          </swiper>

        </div>
        <div class="home_new_list">
          <a :href="'linbiaoinfos?id='+item.product_id"
             v-for="(item,index) in products"
             :key="index">
            <div>{{item.title}}
            </div>
          </a>

        </div>
        <div class="clear"></div>
      </div>
      <div class="image-items">

        <img v-for="(item,index) in advertising"
             @click="navImageClick(item.advertising_href)"
             :key="index"
             v-if="item.advertising_id == 7 ||item.advertising_id == 8||item.advertising_id == 9"
             :src="item.advertising_image"
             style="width:386px;height:230px;cursor:pointer"
             alt="">

      </div>
      <div class="shuju_linbo">
        <div class="shuju_box">
          <div class="home_title"><a href="javascript:;"
               class="left">产业数据库</a><a href="/datalist"
               class="right">更多
              ></a></div>
          <div class="home_new_list">
            <a :href="'/datainfo?id='+item.industry_id"
               v-for="(item,index) in industry"
               :key="index">
              <div>{{item.title}}</div>
            </a>
          </div>
        </div>
        <div class="linbo_box">
          <div class="home_title"><a href="javascript:;"
               class="left">网上林博会</a><a href="/linbolist"
               class="right">更多
              ></a></div>
          <div class="home_new_list">
            <a :href="'/linboinfo?id='+item.limbo_id"
               v-for="(item,index) in limbo"
               :key="index">
              <div>{{item.title}}</div>
            </a>
          </div>
        </div>
      </div>

      <div class="linye_web">
        <div class="home_title"><span class="left">林业网站</span></div>
        <div class="drop_down">
          <div class="drop_list">
            <div class="drop_box"
                 @mousemove="res=>{item1 = true}">
              <div class="mo_name"
                   title="林业网"
                   @mouseleave="res=>{item1=false}">林业网</div>
              <div class="drop_content"
                   v-show="item1"
                   @mouseleave="res=>{item1=false}">
                <a target="_blank"
                   :href="item.friendship_href"
                   v-for="(item,index) in friendsurl.forestry"
                   :key="index">{{item.friendship_name}}</a>
              </div>
            </div>
          </div>
          <div class="drop_list">
            <div class="drop_box"
                 @mousemove="res=>{item2 = true}">
              <div class="mo_name"
                   @mouseleave="res=>{item2=false}"
                   title="地方林业产业网">地方林业产业网</div>
              <div class="drop_content"
                   v-show="item2"
                   @mouseleave="res=>{item2=false}">
                <a target="_blank"
                   :href="item.friendship_href"
                   v-for="(item,index) in friendsurl.Local"
                   :key="index">{{item.friendship_name}}</a>
              </div>
            </div>
          </div>
          <div class="drop_list">
            <div class="drop_box"
                 @mousemove="res=>{item3 = true}">
              <div class="mo_name"
                   @mouseleave="res=>{item3=false}"
                   title="协会学会网">协会学会网</div>
              <div class="drop_content"
                   v-show="item3"
                   @mouseleave="res=>{item3=false}">
                <a target="_blank"
                   :href="item.friendship_href"
                   v-for="(item,index) in friendsurl.association"
                   :key="index">{{item.friendship_name}}</a>
              </div>
            </div>
          </div>
          <div class="drop_list">
            <div class="drop_box"
                 @mousemove="res=>{item4 = true}">
              <div class="mo_name"
                   @mouseleave="res=>{item4=false}"
                   title="地方林业产业网">林业名企网</div>
              <div class="drop_content"
                   v-show="item4"
                   @mouseleave="res=>{item4=false}">
                <a target="_blank"
                   :href="item.friendship_href"
                   v-for="(item,index) in friendsurl.enterprises"
                   :key="index">{{item.friendship_name}}</a>
              </div>
            </div>
          </div>
          <div class="drop_list">
            <div class="drop_box"
                 @mousemove="res=>{item5 = true}">
              <div class="mo_name"
                   title="创新网"
                   @mouseleave="res=>{item5=false}">创新网</div>
              <div class="drop_content"
                   v-show="item5"
                   @mouseleave="res=>{item5=false}">
                <a target="_blank"
                   :href="item.friendship_href"
                   v-for="(item,index) in friendsurl.Innovation"
                   :key="index">{{item.friendship_name}}</a>
              </div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import pdf from 'pdfobject'
// import vueSeamless from 'vue-seamless-scroll'
import user from '@/api/modules/user'
import index from '@/api/modules/index'
export default {
  components:{pdf},
  data () {
    return {
      item1: false,
      item2: false,
      item3: false,
      item4: false,
      item5: false,
      swiperOptions1: {
        loop: true,
        autoplay: true,
        initialSlide: 1,
        speed: 500,
        calculateHeight: true,
        autoplayDisableOnInteraction: true,
        paginationClickable: true,
        spaceBetween: 20,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
        // Some Swiper option/callback...
      },
      swiperOptions2: {
        // loop: true,
        // autoplay: 1000,
        initialSlide: 1,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'

        }
      },
      swiperOptions: {
        // loop: true,
        // autoplay: 4000,
        initialSlide: 1,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'

        }
        // Some Swiper option/callback...
      },
      carousel: {},
      news: {},
      tipnew: {},
      special: {},
      product: {},
      typelist: {},
      publicity: {},
      industry: {},
      limbo: {},
      overall: [],
      optionSeamless: {
        step: 0.7 // 数值越大速度滚动越快
      },
      zhazhilist: [],
      products: [],
      forest: [],
      friendsurl: {
        forestry: [],
        Local: [],
        association: [],
        enterprises: [],
        Innovation: []
      },
      advertising: [],
      overallserver: []

    }
  },
  mounted () {

  },
  methods: {
    magazineDataFormat(e) {
      try {
        return JSON.parse(e.facefile)[0].url;
      }
      catch(err) {
        return;
      }
    },
    magazineDataFormats(e) {
      try {
        // return JSON.parse(e.content)[0].url;
        return JSON.parse(e.contentfile)[0].url;
      }
      catch(err) {
        return;
      }
    },
    bookClick (item, index) {
      if (index == 1 && item.facefile) {
        let file = JSON.parse(item.facefile)[0].url
        console.log(file);

        // this.dow(file)
      }
      if (index == 2 && item.contentfile) {
        let file = JSON.parsgege
        e(item.contentfile)[0].url
        // console.log(file);
        // this.dow(file)
      }
    },

    dow (dowStr) {
      axios({
        method: 'post',
        url: user.blob,
        data: {
          'filename': dowStr
        },
        responseType: 'blob'
      }).then(response => {
        let data = response.data
        if (!data) {
          return
        }
        let url = window.URL.createObjectURL(data)
        console.log(url);
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', dowStr)

        // window.open(url.href, '_blank');

        document.body.appendChild(link)
        link.click()
        // console.log(link);
      })
    },
    // 轮播图列表请求
    carousellist () {
      axios({
        method: 'post',
        url: index.carousellist,
        data: {}
      }).then(res => {
        this.carousel = res.data.list
      })
    },
    navImageClick (herf) {
      window.open(herf)
    },
    // 广告列表请求
    advertisinglist () {
      axios({
        method: 'post',
        url: index.advertisingurl,
        data: {}
      }).then(res => {
        this.advertising = res.data.list
      })
    },

    // 产品资讯请求
    productlists () {
      axios({
        method: 'post',
        url: index.producturl,
        data: {
          'pageSize': '7',
          'page': '1',
          'author': '',
          'title': ''
        }
      }).then(res => {
        this.products = res.data.list
      })
    },

    // 林产品列表请求
    forestllist () {
      axios({
        method: 'post',
        url: index.forestlist,
        data: {
          'pageSize': '10',
          'page': '1',
          'title': ''
        }
      }).then(res => {
        let forer = res.data.list

        this.forest = this.resetDataFun(forer, 2)
        // console.log(this.forest)
      })
    },
    //  拆分
    resetDataFun (stuCount, col) {
      if (stuCount.length > 0) {
        var arr = []
        var cow = stuCount.length / col == 0 ? stuCount.length / col : Math.ceil((stuCount.length / col))
        for (var i = 1; i <= cow; i++) {
          var tempArr = []
          var temp
          if (col * i > stuCount.length) {
            temp = stuCount.length
          } else {
            temp = col * i
          }
          for (var j = col * (i - 1); j < temp; j++) {
            tempArr.push(stuCount[j])
          }
          var newObj = {}
          newObj.data = tempArr
          arr.push(newObj)
        }

        return arr
      }
    },
    // 列表杂志
    zhazhi () {
      axios({
        method: 'post',
        url: index.zhazhilist,
        data: {
          'pageSize': '10',
          'page': '1',
          'year': ''
        }
      }).then(res => {
        this.zhazhilist = res.data.list
      })
    },
    // 专题头条图文列表
    overalllist () {
      axios({
        method: 'post',
        url: index.overalllist,
        data: {
          'level': 40
        }
      }).then(res => {
        this.overall = res.data.list

        this.overall = JSON.parse(res.data.list[0].values)
      })
    },
    // 服务列表
    overallseverlist () {
      axios({
        method: 'post',
        url: index.overalllist,
        data: {
          'level': 20
        }
      }).then(res => {
        this.overallserver = res.data.list

        this.overallserver = JSON.parse(res.data.list[0].values)
      })
    },

    // 头条&图文新闻请求
    newslist () {
      axios({
        method: 'post',
        url: index.newslist,
        data: {
          'pageSize': 2,
          'page': 1,
          'author': '',
          'title': '',
          'types': 10
        }
      }).then(res => {
        this.news = res.data.list
      }) // 头条新闻请求
      axios({
        method: 'post',
        url: index.newslist,
        data: {
          'pageSize': 4,
          'page': 1,
          'author': '',
          'title': '',
          'types': 20
        }
      }).then(res => {
        this.tipnew = res.data.list
      }) // 图文新闻请求
    },

    // 专题请求
    speciallist () {
      axios({
        method: 'post',
        url: index.speciallist,
        data: {
          pageSize: 2,
          page: 1
        }
      }).then(res => {
        this.special = res.data.list
      })
    },
    // 资讯请求
    productlist () {
      axios({
        method: 'post',
        url: index.productlist,
        data: {
          'pageSize': 14,
          'page': 1
        }
      }).then(res => {
        this.product = res.data.list
      })
      axios({
        method: 'post',
        url: index.informationList,
        data: {}
      }).then(res => {
        this.typelist = res.data.list
      })
    },
    publicitylist () {
      axios({
        method: 'post',
        url: index.publicitylist,
        data: {
          'pageSize': 10,
          'page': 1
        }
      }).then(res => {
        this.publicity = res.data.list
      })
    },
    industrylist () {
      axios({
        method: 'post',
        url: index.industrylist,
        data: {
          'pageSize': 5,
          'page': 1
        }
      }).then(res => {
        this.industry = res.data.list
      })
    },
    navlibiaoClick (item) {
      // console.log(item);
      this.$router.push({ path: '/linbiaoinfo', query: {'id': item.forest_id} })
    },
    limbolist () {
      axios({
        method: 'post',
        url: index.limbolist,
        data: {
          'pageSize': 5,
          'page': 1
        }
      }).then(res => {
        this.limbo = res.data.list
      })
    },
    friendship () {
      axios({
        method: 'post',
        url: index.friendsurl,
        data: {}
      }).then(res => {
        let data = res.data.list
        for (let i in data) {
          if (data[i].friendship_types == '10') {
            this.friendsurl.forestry.push(data[i])
          } else if (data[i].friendship_types == '20') {
            this.friendsurl.Local.push(data[i])
          } else if (data[i].friendship_types == '30') {
            this.friendsurl.association.push(data[i])
          } else if (data[i].friendship_types == '40') {
            this.friendsurl.enterprises.push(data[i])
          } else if (data[i].friendship_types == '50') {
            this.friendsurl.Innovation.push(data[i])
          }
        }
        // console.log(this.friendsurl)
      })
    }
  },
  // components: {
  //   // vueSeamless
  // },
  created () {
    this.carousellist()
    this.newslist()
    this.speciallist()
    this.productlist()
    this.publicitylist()
    this.industrylist()
    this.limbolist()
    this.overalllist()
    this.zhazhi()
    this.forestllist()
    this.friendship()
    this.productlists()
    this.advertisinglist()
    this.overallseverlist()
  },

  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  }
}

</script>

<style scoped>
* {
  text-decoration: none;
}

#main {
  margin-top: 20px;
}

.wh1200 {
  max-width: 1200px;
  margin: 0 auto;
}

.tongzhi {
  padding: 20px 0px 20px 30px;
  background: url(../static/tongzhi_bg.png) center center no-repeat;
  width: 100%;
  height: 140px;
  box-sizing: border-box;
  position: relative;
  margin-top: 40px;
}

.tongzhi .tongzhi_name {
  position: absolute;
  top: -12px;
  left: 5px;
  font-size: 20px;
  color: #cc0001;
  font-weight: bold;
}
.tongzhi .tongzhi_name img {
  vertical-align: top;
  margin-right: 8px;
  position: relative;
  top: 3px;
}
.tongzhi .tongzhi_content {
  position: relative;
  height: 80px;
  overflow: hidden;
  top: 10px;
}

.swiper-button-next,
.swiper-button-prev {
  width: 40px;
  height: 40px;
  margin-top: -20px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  color: #fff;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
}
.swiper-button-prev {
  background: rgba(0, 0, 0, 0.5);
  left: 0px;
}
.swiper-button-prev:hover {
  background: rgba(0, 0, 0, 0.8);
}
.swiper-button-next {
  background: rgba(0, 0, 0, 0.5);
}
.swiper-button-next:hover {
  background: rgba(0, 0, 0, 0.8);
}
.top_swiper {
  width: 720px;
}

.swiper_text-content {
  position: relative;
}

.swiper_text-content > img {
  display: block;
  height: 400px;
  width: 720px;
}

.swiper_text {
  position: absolute;
  bottom: 0px;
  height: 60px;
  line-height: 60px;
  background: rgba(0, 0, 0, 0.5);
  font-size: 18px;
  color: #fff;
  left: 0px;
  right: 0px;
  bottom: 0px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  padding: 0px 90px 0px 20px;
}

.home_top {
  display: flex;
}

.home_top .right_tuijian {
  float: left;
  width: 37%;
  margin-left: 35px;
}

.home_top .right_tuijian > div {
  font-size: 18px;
  display: table;
  line-height: 50px;
  height: 50px;
  color: #333333;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  color: #000;
}
.home_top .right_tuijian > div a {
  color: #000;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}
.home_top .right_tuijian a:hover {
  color: #cc0001;
}
.home_top .right_tuijian a div {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  position: relative;
}

.home_top .right_tuijian .a_toutiao a {
  font-weight: bold;
  color: #cc0001;
}

.home_top .right_tuijian .a_toutiao a:hover {
  color: rgba(204, 0, 1, 0.6);
}

.home_top .right_tuijian .a_zhuanti {
  padding-left: 50px;
  position: relative;
}
.home_top .right_tuijian .a_zhuanti a {
  color: #000;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.home_top .right_tuijian .a_zhuanti a div {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.home_top .right_tuijian .a_zhuanti a:hover {
  color: #cc0001;
}
.home_top .right_tuijian .a_zhuanti:before {
  position: absolute;
  content: "专题";
  display: block;
  left: 0px;
  top: 14px;
  width: 42px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #cc0001;
}

.tongzhi .tongzhi_content .tongzhi_box .tongzhi_link {
  overflow: hidden;
  padding-right: 20px;
}

.tongzhi .tongzhi_content .tongzhi_box .tongzhi_link a {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #333333;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  float: left;
  width: 50%;
  padding: 0px 40px 0px 30px;
  box-sizing: border-box;
  background: url(../static/tongzhi_yuan.png) left center no-repeat;
}

.tongzhi .tongzhi_content .tongzhi_box .tongzhi_link a:hover {
  color: #cc0001;
}

.adv_01 {
  display: block;
  margin-top: 20px;
}

.adv_01 img {
  width: 100%;
  display: block;
}

.zixun_pingtai {
  overflow: hidden;
  margin-top: 20px;
}

.zixun_pingtai .zixun_box {
  float: left;
  width: 60%;
}

.swiper-pagination {
  width: auto !important;
  left: auto !important;
  right: 15px !important;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  bottom: 15px !important;
}

.zixun_pingtai .zixun_box .zixun_box_content {
  margin-top: 20px;
}

.zixun_pingtai .zixun_box .zixun_box_content a {
  display: table;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  font-size: 16px;
  color: #333333;
  height: 40px;
  line-height: 40px;
  margin-top: 4.5px;
}

.zixun_pingtai .zixun_box .zixun_box_content a span {
  color: #cc0001;
}

.zixun_pingtai .zixun_box .zixun_box_content a div {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.zixun_pingtai .zixun_box .zixun_box_content a:hover {
  color: #cc0001;
}

.zixun_pingtai .pingtai_box {
  float: right;
  width: 37%;
}

.zixun_pingtai .pingtai_box ul {
  overflow: hidden;
  margin: 10px -10px;
}

.zixun_pingtai .pingtai_box ul li {
  float: left;
  width: 50%;
  box-sizing: border-box;
  padding: 10px;
}

.zixun_pingtai .pingtai_box ul li a {
  display: block;
  height: 58px;
  line-height: 58px;
  text-align: center;
  border: 1px solid #dddddd;
  border-radius: 3px;
  font-size: 20px;
  color: #333333;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.zixun_pingtai .pingtai_box ul li a:hover {
  border: 1px solid #cc0001;
  color: #cc0001;
}

.zixun_pingtai .pingtai_swiper {
  margin-top: 20px;
  position: relative;
}

.zixun_pingtai .pingtai_swiper .swiper_box {
  overflow: hidden;
  margin: 0px -10px;
}

.zixun_pingtai .pingtai_swiper .swiper_box .box_list {
  float: left;
  width: 50%;
  box-sizing: border-box;
  padding: 0px 10px;
}

.zixun_pingtai .pingtai_swiper .swiper_box .box_list a {
  display: block;
  height: 286px;
  background-size: cover !important;
  position: relative;
  cursor: pointer;
}

.zixun_pingtai .pingtai_swiper .swiper_box .box_list a .swiper_text {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 0px 10px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  background: rgba(0, 0, 0, 0.5);
}

.home_title {
  font-size: 20px;
  border-bottom: 1px solid #cc0001;
  font-weight: bold;
  height: 45px;
  line-height: 45px;
  overflow: hidden;
}

.home_title .left {
  display: block;
  position: relative;
  color: #333333;
  float: left;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.home_title .left:before {
  content: "";
  display: block;
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 4px;
  background: #cc0001;
}

.home_title .right {
  float: right;
  font-size: 16px;
  color: #666666;
  display: block;
  font-weight: normal;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.home_title a:hover {
  color: #cc0001;
}

.shengtai {
  margin-top: 30px;
}
.swiper_button_box {
  width: 50%;
  position: absolute;
  height: 100%;
  left: 0px;
  top: 0px;
}
.shengtai .shengtai_swiper {
  float: left;
  width: 48%;
  margin-top: 20px;
}

.shengtai .shengtai_swiper .swiper-button-next {
  right: 0px;
}

.shengtai .shengtai_swiper .swiper_con:hover .bottom_box .name {
  color: #cc0001;
}

.shengtai .shengtai_swiper .swiper_con {
  display: block;
}

.shengtai .shengtai_swiper .swiper_con .top_img {
  height: 200px;
  background-size: cover !important;
}

.shengtai .shengtai_swiper .swiper_con .bottom_box {
  background: #f3f3f3;
  padding: 15px;
  border: 1px solid #dddddd;
  border-top: none;
}

.shengtai .shengtai_swiper .swiper_con .bottom_box .name {
  font-size: 16px;
  color: #333333;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.shengtai .shengtai_swiper .swiper_con .bottom_box .text {
  font-size: 14px;
  color: #888888;
  line-height: 20px;
  height: 40px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  margin-top: 10px;
}

.shengtai .home_new_list {
  float: right;
  width: 48%;
}

.home_new_list {
  margin-top: 20px;
}

.home_new_list a {
  display: table;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  color: #333333;
  padding-left: 30px;
  background: url(../static/tongzhi_yuan.png) left center no-repeat;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
}

.home_new_list a div {
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.home_new_list a:hover {
  color: #cc0001;
}

.linye_web {
  margin-top: 20px;
}

.linye_web .drop_down {
  margin: 0px -10px;
  margin-top: 20px;
}

.linye_web .drop_down .drop_list {
  float: left;
  width: 20%;
  box-sizing: border-box;
  padding: 0px 10px;
}

.linye_web .drop_down .drop_list .drop_box {
  position: relative;
}

.linye_web .drop_down .drop_list .drop_box .mo_name {
  height: 38px;
  line-height: 38px;
  border: 1px solid #dddddd;
  border-radius: 3px;
  font-size: 14px;
  color: #333333;
  padding: 0px 40px 0px 15px;
  cursor: pointer;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  background: url(../static/mo_name_icon.png) right 15px center no-repeat;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.linye_web .drop_down .drop_list .drop_box .mo_name.active {
  background: url(../static/mo_name_icon02.png) right 15px center no-repeat;
  color: #cc0001;
}

.linye_web .drop_down .drop_list .drop_box .mo_name:hover {
  color: #cc0001;
}

.linye_web .drop_down .drop_list .drop_box .drop_content {
  position: absolute;
  left: 0px;
  top: 40px;
  right: 0px;
  padding: 10px 0px;
  border: 1px solid #dddddd;
  border-top: none;
  border-radius: 0px 0px 3px 3px;
  box-sizing: border-box;
  max-height: 160px;
  overflow-x: hidden;
  z-index: 20;
  background: #fff;
}

.linye_web .drop_down .drop_list .drop_box .drop_content a {
  display: block;
  font-size: 14px;
  color: #333333;
  height: 35px;
  line-height: 35px;
  -webkit-transition: all 0.2s ease-out;
  -khtml-transition: all 0.2s ease-out;
  -moz-transition: all 0.2s ease-out;
  -o-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
  padding: 0px 10px;
}

.linye_web .drop_down .drop_list .drop_box .drop_content a:hover {
  background: #cc0001;
  color: #fff;
}

.shuju_linbo {
  height: 262px;
}

.shuju_linbo .shuju_box {
  width: 48%;
  float: left;
}

.shuju_linbo .linbo_box {
  width: 48%;
  float: right;
}
.image-items {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.image-items > img {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
}

.zazhi_dingzhi {
  overflow: hidden;
  padding: 15px 20px 13px 20px;
  background: #eb3e14;
  margin-top: 27px;
}
.zazhi_dingzhi .left_box {
  float: left;
}
.zazhi_dingzhi .left_box .left_b_name {
  font-size: 16px;
  color: #fff;
}
.zazhi_dingzhi .left_box .left_b_text {
  font-size: 18px;
  color: #fff;
  font-weight: bold;
  margin-top: 7px;
}
.zazhi_dingzhi .right_img {
  float: right;
}
.zhazhi {
  /* border: 1px solid red; */
}
.swiper_text-contents {
  display: flex;
  cursor: pointer;
}
.banner-set {
  position: relative;
}
.banner-set img {
  display: block;
}
.swiper_texts {
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 0px 10px;
  display: -webkit-box !important;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  background: rgba(0, 0, 0, 0.5);
}
.adv_02 {
  margin-top: 20px;
}
.adv_02 ul {
  /* margin: 0px -10px;
    overflow: hidden; */
  display: flex;
  justify-content: space-between;
  margin: 0px;
  padding: 0px;
}
.swiper_texts_shengtai_swiper {
  background: #f3f3f3;
  padding: 15px;
  border: 1px solid #dddddd;
  margin-top: -6px;
  height: 70px;
  z-index: 10000;
  width: 246px;
}
.shengtai .shengtai_swiper .top_img {
  height: 200px;
  background-size: cover !important;
}
.shengtai a {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue